<elcia-dropdown
  [control]="control()"
  [items]="options()"
  [label]="'product.frequency' | translate"
  [textField]="'name'"
  [valueField]="'id'"
/>
